import Navbar from "../Components/Navbar";

function Header() {
  return (
    <header>
        <Navbar />
    </header>
  );
}

export default Header;